/**
 * @generated SignedSource<<8e1adc19122f77c75066b579138afa59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsClubSellingStandardPackages_club$data = {
  readonly standardPackages: {
    readonly count: number;
  } | null | undefined;
  readonly " $fragmentType": "useIsClubSellingStandardPackages_club";
};
export type useIsClubSellingStandardPackages_club$key = {
  readonly " $data"?: useIsClubSellingStandardPackages_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsClubSellingStandardPackages_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useIsClubSellingStandardPackages_club",
  "selections": [
    {
      "alias": "standardPackages",
      "args": [
        {
          "kind": "Literal",
          "name": "packageType",
          "value": "STANDARD"
        },
        {
          "kind": "Literal",
          "name": "saleAvailability",
          "value": "PUBLIC"
        }
      ],
      "concreteType": "PackageConnection",
      "kind": "LinkedField",
      "name": "packages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": "packages(packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "fa1c2a033387df9196cead12248a10be";

export default node;
